import './LobbyTimer.css'

import React from 'react';
import { useCountdown } from '../../../Room/components/RoomTimer/hooks/useCountdown';
import DateTimeDisplay from '../../../Room/components/RoomTimer/DateTimeDisplay';


const ExpiredNotice = () => {
	return (
		<div className="expired-notice-lobby">
			<span>Time is Up!</span>
		</div>
	);
};

const ShowCounter = ({ days, hours, minutes, seconds }) => {
	return (
		<div className="show-counter-lobby">
			<DateTimeDisplay 
				value={days} 
				type={'Days'} 
				isDanger={false} />

			<p>:</p>

			<DateTimeDisplay 
				value={hours} 
				type={'Hours'} 
				isDanger={false} />

			<p>:</p>

			<DateTimeDisplay 
				value={minutes}
				type={'Mins'}
				isDanger={minutes < 5 && days === 0 && hours === 0} />

			<p>:</p>

			<DateTimeDisplay 
				value={seconds} 
				type={'Seconds'} 
				isDanger={minutes < 5 && days === 0 && hours === 0} />
		</div>
	);
};

const LobbyTimer = ({ time, handleTimesUp }) => {	

	const [days, hours, minutes, seconds] = useCountdown(time);

	if (days + hours + minutes + seconds === 0){
		return <div>Loading...</div>
	}
	else if (days + hours + minutes + seconds < 0) {
		handleTimesUp()
		return <ExpiredNotice />;
        
	} else {
		return (
			<ShowCounter
			days={days}
			hours={hours}
			minutes={minutes}
			seconds={seconds}
			/>
		);
	}
};

export default LobbyTimer;
